<section class="time-sheet-page insights-page">
  <div class="insights-shell">
  <header class="insights-hero">
    <div class="insights-hero-copy">
      <h1>Weekly timesheet</h1>
      <p class="insights-lead">Capture and review logged hours for each day.</p>
    </div>

    <div class="page-header-actions">
      <app-time-sheet-date-selector
        layout="pill"
        (weekChange)="onWeekChange($event)"
      />
      @if (myProjects().length || filterProject()) {
        <app-project-dropdown
          class="header-project-dropdown"
          [projects]="myProjects()"
          [selectedProject]="filterProject()"
          [allowNull]="true"
          [nullOptionLabel]="'All projects'"
          [compact]="true"
          [disabled]="loading()"
          (projectSelected)="onFilterProjectSelected($event)"
        />
      }
    </div>
  </header>

  @if (loading()) {
    <div
      class="time-sheet-spinner d-flex justify-content-center align-items-center"
    >
      <span class="spinner-border" aria-hidden="true"></span>
    </div>
  } @else {
    <div class="week-days" aria-label="Weekly timesheet">
      @for (day of weekDays(); track day.getTime()) {
        <app-time-sheet-day
          [date]="day"
          [projects]="projects()"
          [projectColorById]="projectColorById()"
          [entries]="entriesByDate().get(localCalendarDayKey(day)) ?? []"
          [weekEntries]="weekEntries()"
          [defaultProjectId]="filterProject()?.id ?? ''"
          (save)="onTimeSheetEntrySaved($event)"
        />
      }
    </div>
  }
  </div>
</section>
